export default __webpack_public_path__ + "static/media/AMS House History2.02abd5e8.svg";